<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">더치페이</span>
      <button class="btn-pop-close" @click="$.emit('closeModal')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset admin-mt20">
        <div class="ip-row md">
          <label for="totalPrice">받을금액</label>
          <input
            type="text"
            class="ip-comm fc-pink"
            id="totalPrice"
            :value="
              (totalUprc - totalDiscount - receivedUprc)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
          />
        </div>
        <div class="ip-row md">
          <label for="totalPrice">결제 대상금액</label>
          <input
            type="text"
            class="ip-comm fc-blue"
            id="amount"
            @change="changeAmount()"
            @input="inputAmount()"
            :value="amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
          />
        </div>
        <div class="ip-row md">
          <label for="totalPrice">고객수</label>
          <div class="btn-count-area">
            <button
              type="button"
              class="btn-option-minus"
              :disabled="!isChangeCnt"
              @click="peopleCnt > 0 ? (peopleCnt--, changePeople()) : false"
            >
              <span class="overlay"></span>
            </button>
            <input type="text" class="ip-comm sm center" :value="peopleCnt" />
            <button
              type="button"
              class="btn-option-plus"
              :disabled="!isChangeCnt"
              @click="peopleCnt++, changePeople()"
            >
              <span class="overlay"></span>
            </button>
          </div>
          <button
            type="button"
            class="btn-smd btn-main"
            @click="
              (peopleCnt = 0), (dutchArr = new Array()), (selectCode = null)
            "
          >
            초기화<span class="overlay"></span>
          </button>
        </div>
      </div>

      <table class="tb-lst-payment tb-dutchpay-pop">
        <thead>
          <tr>
            <td>No.</td>
            <td>결제금액</td>
            <td>결제구분</td>
            <td>비고</td>
          </tr>
        </thead>
        <tbody id="tableGroupScroll">
          <tr
            @click="dutchSelect(i)"
            :class="{ on: selectCode == i }"
            v-for="(dutch, i) in dutchArr"
            :key="dutch"
          >
            <td>{{ i + 1 }}</td>
            <td>
              {{ dutch.amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
            </td>
            <td>
              {{
                dutch.payType != ""
                  ? dutch.payType == "cash"
                    ? "현금"
                    : "카드"
                  : ""
              }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="pop-btn-area with-scroll-btn col04">
      <div class="btn-arr-area">
        <button class="admin-btn-up" @click="scrollMove(-50)">
          <span class="overlay"></span>
        </button>
        <button class="admin-btn-down" @click="scrollMove(50)">
          <span class="overlay"></span>
        </button>
      </div>
      <button
        type="button"
        class="btn-pop btn-submit sm"
        @click="payment('cash')"
      >
        현금 결제<span class="overlay"></span>
      </button>
      <button
        type="button"
        class="btn-pop btn-submit sm"
        @click="payment('card')"
      >
        카드 결제<span class="overlay"></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "dutchPayment",
  data() {
    return {
      peopleCnt: 0,
      amount: 0,
      isChangeCnt: true,
      dutchArr: new Array(),
      selectCode: null,
    };
  },
  methods: {
    dutchSelect(i) {
      if (this.selectCode == i) this.selectCode = null;
      else this.selectCode = i;
    },
    changeAmount() {
      let cash = event.target.value.replace(/\D/g, "");
      if (cash == 0) this.isChangeCnt = true;
      else {
        this.isChangeCnt = false;
        this.dutchArr = [];
        this.peopleCnt = 0;
      }

      this.selectCode = null;
    },
    inputAmount() {
      let cash = event.target.value.replace(/\D/g, "");
      if (cash.length == 0) cash = 0;
      cash = parseInt(cash, 10);

      event.target.value = cash;
      this.amount = event.target.value;
      if (cash == 0) this.isChangeCnt = true;
      else {
        this.isChangeCnt = false;
        this.dutchArr = [];
        this.peopleCnt = 0;
      }
      this.selectCode = null;
    },
    changePeople() {
      this.dutchArr = new Array();
      let uprc = this.totalUprc - this.totalDiscount - this.receivedUprc;
      let peopleUprc = uprc / (this.peopleCnt * 10);
      let remainUprc = uprc % (this.peopleCnt * 10);

      for (let i = 0; i < this.peopleCnt; i++) {
        let amt = parseInt(peopleUprc) * 10;
        if (i == this.peopleCnt - 1) amt += remainUprc;
        this.dutchArr.push({
          amt: amt,
          payType: "",
        });
      }
    },
    payment(type) {
      if (this.selectCode != null) {
        this.$emit("dutchPay", type, this.dutchArr[this.selectCode].amt);
        this.dutchArr[this.selectCode].payType = type;
      } else {
        if (this.amount == 0) return;
        this.$emit("dutchPay", type, this.amount);
      }
      this.amount = 0;
    },
    loadingPromise(text) {
      this.$.emit("openLoading", text);
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$.emit("closeLoading");
          resolve(1);
        }, 1000);
      });
    },
    scrollMove(moveY) {
      var scroll = document.getElementById("tableGroupScroll");
      scroll.scrollTop += moveY;
      //scroll.scrollTo({ top: scroll.scrollHeight + moveY, behavior: "smooth" });
    },
  },
  props: {
    totalUprc: Number,
    totalDiscount: Number,
    receivedUprc: Number,
    dutchUprc: Number,
  },
  watch: {
    dutchUprc(val) {
      if (val >= 0) {
        this.amount = val;
        if (val == 0) this.isChangeCnt = true;
        else this.isChangeCnt = false;
        this.selectCode = null;
      }
    },
    async sumUprc(val) {
      if (val <= 0) {
        await this.loadingPromise("결제완료 처리 중입니다.");
        await this.loadingPromise("영수증 출력 중입니다.");
        this.$.emit("removeComplexPayArr", -1);
        this.$.emit("resetBasket", "003");
        this.$.emit("close");
      }
    },
  },
  computed: {
    sumUprc() {
      let uprc = this.totalUprc - this.totalDiscount - this.receivedUprc;

      return uprc;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped>
</style>


